import {create} from "zustand";
import type {Booking} from "shared-types";
import {bookingApi} from '../../services/api';

interface BookingCalendarState {
    bookings: Booking[];
    loading: boolean;
    error: string | null;
    fetchBookings: (params?: { roomId?: string }) => Promise<void>;
    createBooking: (booking: Partial<Booking>) => Promise<void>;
    updateBooking: (id: string, booking: Partial<Booking>) => Promise<void>;
    deleteBooking: (id: string) => Promise<void>;
    fetchBookingsByRoomId: (roomId: string) => Promise<void>;
}

export const useBookingCalendarStore = create<BookingCalendarState>((set) => ({
    bookings: [],
    loading: false,
    error: null,

    /**
     * טוען את כל ההזמנות מהחנות (או מסנן לפי roomId אם נשלח).
     * כרגע עובד על נתוני דמה בלבד.
     * @param params אובייקט אופציונלי עם roomId לסינון
     */
    fetchBookings: async (params) => {
        const calendarId = process.env.REACT_APP_CALENDARID;
        console.log("REACT_APP_CALENDER_ID:", calendarId);
        set({loading: true, error: null});
        try {
            console.log("Before fetch");
            const data = await bookingApi.getAllByCalendar(calendarId || '');
            console.log("After fetch", {data});
            set(() => ({
                bookings: params?.roomId
                    ? data.filter((b: Booking) => b.roomId === params.roomId)
                    : data,
                loading: false
            }));
            console.log("this is us data!!!!!!!!!", data);
        } catch (error) {
            set({error: 'Failed to fetch bookings', loading: false});
        }
    },

    /**
     * מוסיף הזמנה חדשה לחנות.
     * כרגע מוסיף לנתוני הדמה בלבד.
     * @param booking אובייקט הזמנה חדשה (חלקי)
     */
    createBooking: async (booking) => {
        set({loading: true, error: null});
        try {
            const newBooking = await bookingApi.create(booking);
            set((state) => ({
                bookings: [...state.bookings, newBooking],
                loading: false
            }));
        } catch (error) {
            set({error: 'Failed to create booking', loading: false});
        }
    },

    /**
     * מעדכן הזמנה קיימת לפי מזהה.
     * כרגע מעדכן בנתוני הדמה בלבד.
     * @param id מזהה ההזמנה לעדכון
     * @param booking אובייקט עם שדות לעדכון
     */
    updateBooking: async (id, booking) => {
        set({loading: true, error: null});
        try {
            const updatedBooking = await bookingApi.update(id, booking);
            set((state) => ({
                bookings: state.bookings.map(b => b.id === id ? updatedBooking : b),
                loading: false
            }));
        } catch (error) {
            set({error: 'Failed to update booking', loading: false});
        }
    },

    /**
     * מוחק הזמנה לפי מזהה.
     * כרגע מוחק מנתוני הדמה בלבד.
     * @param id מזהה ההזמנה למחיקה
     */
    deleteBooking: async (id) => {
        set({loading: true, error: null});
        try {
            await bookingApi.delete(id);
            set((state) => ({
                bookings: state.bookings.filter(b => b.id !== id),
                loading: false
            }));
        } catch (error) {
            set({error: 'Failed to delete booking', loading: false});
        }
    },

    /**
     * טוען את כל ההזמנות של חדר מסוים לפי roomId.
     * כרגע מחזיר נתוני דמה בלבד.
     * @param roomId מזהה החדר
     */
    fetchBookingsByRoomId: async (roomId: string) => {
        set({loading: true, error: null});
        try {
            const bookings = await bookingApi.getByRoomId(roomId);
            set({bookings, loading: false});
        } catch (error) {
            set({error: 'Failed to fetch bookings by room', loading: false});
        }
    }
}));
